import {
  adminRoutes,
  authRoutes,
  checkInRoutes,
  companyRoutes,
  eventRoutes,
  generalRoutes,
  gremiumRoutes,
  userRoutes,
  globalNewsRoutes,
  surveyRoutes,
  guestRoutes,
  matchingRoutes,
  legalRoutes,
  miscRoutes,
  partnerRoutes,
  projectRoomRoutes,
  travelExpenseRoutes,
  lectureRoutes,
  // Remove these routes as they're now only accessible through admin
  // topicCategoryRoutes,
  // lectureEventRoutes
} from "./routes/index";

export default ({ authGuard, guestGuard, externalGuard }) => [
  {
    path: "/",
    redirect: (to) =>
      localStorage.getItem("auth-token")
        ? { name: "home" }
        : { name: "login", query: { redir: to.fullPath } },
  },
  ...externalGuard([...guestRoutes]),
  ...guestGuard([...authRoutes]),
  ...authGuard([
    ...adminRoutes,
    ...checkInRoutes,
    ...companyRoutes,
    ...generalRoutes,
    ...gremiumRoutes,
    ...userRoutes,
    ...eventRoutes,
    ...globalNewsRoutes,
    ...surveyRoutes,
    ...legalRoutes,
    ...matchingRoutes,
    ...partnerRoutes,
    ...projectRoomRoutes,
    ...travelExpenseRoutes,
    ...lectureRoutes,
    // Remove lectureEventRoutes from being directly accessible
    // ...lectureEventRoutes
  ]),

  ...miscRoutes,
];
